// Our main CSS
import '../css/app.css'

/**
 * Vue is ready for you, if you need it.
 */

/**
 * The following block of code automatically registers your Vue components.
 * It will recursively scan this directory for the Vue components and
 * automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 *
 * Feel free to remove this block if you don't like black magic fuckery,
 * or you want to register your Vue components manually.
 */
/*
 *** https://v3.vuejs.org/
 */
// interface ImportedModule {
//   name: string
//   default: object
// }
// const vueSingleFileComponents = import.meta.glob<ImportedModule>('./**/*.vue', {
//   eager: true
// })

// import { createApp } from 'vue'
// const app = createApp({})

// for (const path in vueSingleFileComponents) {
//   const importedModule = vueSingleFileComponents[String(path)]
//   const name = path.split('/').pop()?.split('.')[0]
//   if (name !== undefined && typeof name === 'string') {
//     app.component(name, importedModule.default)
//   }
// }
// app.mount('#vue-app')

/**
OR:
const ExampleVueComponentWrapper = document.getElementById('ExampleVueComponentWrapper')
if (ExampleVueComponentWrapper && ExampleVueComponentWrapper !== null) {
  import('./ExampleVueComponent/index.js')
    .then((module) => {
      module.default(ExampleVueComponentWrapper as HTMLElement)
    })
    .catch((err) => {
      console.log(err)
      // main.textContent = err.message;
    })
}

Load a js-module dynamically, if the parent element exists, in this example, a vue component. (The js-file wont load if html element with id #ExampleVueComponentWrapper does not exists)
*/

/**
 * 🦄: Now do your magic.
 */

const initNonCritical = async () => {
  // Lazy load video handling
  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]')
  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
    Intersecting elements helper
*/
  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}

const button = document.getElementById('nav-icon')
const menu = document.getElementById('main-menu')

function toggleMenu() {
  if (!button || !menu) {
    return
  }
  const expanded = button.getAttribute('aria-expanded') === 'true'

  button.setAttribute('aria-expanded', (!expanded).toString())

  document.body.classList.toggle('menu-open')

  if (document.body.classList.contains('menu-open')) {
    menu.removeAttribute('inert')
    menu.style.transform = 'translateX(0)'

    const firstFocusable = menu.querySelector<HTMLElement>(
      'a, button, [tabindex]:not([tabindex="-1"])'
    )
    firstFocusable?.focus()
  } else {
    menu.setAttribute('inert', '')
    menu.style.transform = 'translateX(-100%)'

    button.focus()
  }
}

button?.addEventListener('click', toggleMenu)

menu?.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', toggleMenu)
})

// Close menu on resize if desktop
window.addEventListener('resize', () => {
  if (window.innerWidth >= 1280 && document.body.classList.contains('menu-open')) {
    toggleMenu()
  }
})

// Init SplideJS for cards block if it exists on the page
const cards_splide = document.querySelector('[data-cards-splide]') as HTMLElement

if (cards_splide) {
  import('./modules/splidejs').then(({ default: initCardsSplide }) => {
    initCardsSplide()
  })
}

// Init FAQ accordion if it exists on the page
const faqAccordion = document.querySelector('[data-accordion-root]') as HTMLElement

if (faqAccordion) {
  import('./modules/accordion').then(({ default: initFaqAccordionMultiOpen }) => {
    initFaqAccordionMultiOpen()
  })
}
